import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCategoryForm from '../../../components/forms/MemberCategoryForm';
import { useCreateMemberCategory } from '../../../hooks/useMemberCategoryApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberCategoryDTO } from '../../../services/apiClient';

const MemberCategoryCreate: React.FC = () => {
  const createMutation = useCreateMemberCategory();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Categories', href: '/admin/membercategories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberCategoryDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/membercategories');
    } catch (error) {
      console.error('Error creating MemberCategory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.MemberCategory.Edit"
    >
        <MemberCategoryForm
          initialValues={{} as MemberCategoryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/membercategories')}
        />
    </AdminLayout>
  );
};

export default MemberCategoryCreate;
